import { IconCheck } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconTick: FC<IconProps> = props => (
  <SvgIcon {...props} component={IconCheck} />
)

export default IconTick
